/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-11 19:21:09
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:52:59
 */

import SrmPage from '../login/login'    // 登录

import FileRecord from '../demo/fileRecord'
import Performance from '../demo/performance'
/** home */
import TabPage from '../home/tabPage'
import Home from '../home/Home'
import Message from '../home/Message'
import Mine from '../home/mine'
/** quote */
import QuoteList from '../quote/quoteList'
import Alex from '../quote/alex'
import Quote from '../quote/quote'
/** order */
import OrderComfirm from '../order/orderComfirm'
import OrderSearch from '../order/orderSearch'
import Order from '../order/order'
/** auction */
import AuctionList from '../auction/auctionList'
/** delivery */
import DeliveryList from '../delivery/deliveryList'
import NoticeList from '../delivery/noticeList'
import Delivery from '../delivery/delivery'
import Notice from '../delivery/notice'
/** pending */
import InteriorPendingList from '../pending/interiorPendingList'
import SupplierPendingList from '../pending/supplierPendingList'

let router = [

  {
    path: '/Alex',
    name: 'Alex',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/alex'),
    backPath: ''
  },
  {
    path: '/srmLogin',
    name: 'srmLogin',
    component: () => import(/* webpackChunkName: 'srmPage' */ '@/page/srm/login/login'),
    backPath: ''
  },
  {
    path: '/TabPage',
    name: 'TabPage',
    component: TabPage,
    backPath: '',
    children: [
      {
        path: '/',
        redirect: {name: 'home'},
        backPath: ''
      },
      {
        path: '/home',
        name: 'home',
        component: Home,
        backPath: ''
      },
      {
        path: '/message',
        name: 'message',
        component: Message,
        backPath: ''
      },
      {
        path: '/mine',
        name: 'mine',
        component: Mine,
        backPath: ''
      }
    ]
  },
  {
    path: '/FileList',
    name: 'FileList',
    component: () => import(/* webpackChunkName: 'fileRecord' */ '@/page/srm/demo/fileList'),
    backPath: ''
  },
  {
    path: '/FileRecord',
    name: 'FileRecord',
    component: () => import(/* webpackChunkName: 'fileRecord' */ '@/page/srm/demo/fileRecord'),
    backPath: ''
  },
  {
    path: '/Performance',
    name: 'Performance',
    component: () => import(/* webpackChunkName: 'performance' */ '@/page/srm/demo/performance'),
    backPath: ''
  },
  {
    path: '/QuoteList',
    name: 'QuoteList',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/quoteList'),
    backPath: ''
  },
  {
    path: '/Quote',
    name: 'Quote',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/quote'),
    backPath: ''
  },
  {
    path: '/AuctionList',
    name: 'AuctionList',
    component: () => import(/* webpackChunkName: 'auction' */ '@/page/srm/auction/auctionList'),
    backPath: ''
  }, {
    path: '/actionEdit',
    name: 'actionEdit',
    component: () => import(/* webpackChunkName: 'auction' */ '@/page/srm/auction/actionEdit'),
    backPath: ''
  },
  {
    path: '/OrderComfirm',
    name: 'OrderComfirm',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/orderComfirm'),
    backPath: ''
  },
  {
    path: '/OrderSearch',
    name: 'OrderSearch',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/orderSearch'),
    backPath: ''
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/order'),
    backPath: ''
  },
  {
    path: '/QuarterPerformance',
    name: 'QuarterPerformance',
    component: () => import(/* webpackChunkName: 'performance' */ '@/page/srm/performance/quarterPerformanceList'),
    backPath: ''
  },
  {
    path: '/AnnualPerformance',
    name: 'AnnualPerformance',
    component: () => import(/* webpackChunkName: 'performance' */ '@/page/srm/performance/annualPerformanceList'),
    backPath: ''
  },
  {
    path: '/AccountStmtList',
    name: 'AccountStmtList',
    component: () => import(/* webpackChunkName: 'performance' */ '@/page/srm/rcn/accountStmtList'),
    backPath: ''
  },
  {
    path: '/AccountStmtDetail',
    name: 'AccountStmtDetail',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/rcn/accountStmtDetail'),
    backPath: ''
  },
  {
    path: '/DeliveryList',
    name: 'DeliveryList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/deliveryList'),
    backPath: ''
  },
  {
    path: '/NoticeList',
    name: 'NoticeList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/noticeList'),
    backPath: ''
  },{
    path: '/NoticeListConfirm',
    name: 'NoticeListConfirm',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/noticeListConfirm'),
    backPath: ''
  },
  {
    path: '/Delivery',
    name: 'Delivery',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/delivery'),
    backPath: ''
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/notice'),
    backPath: ''
  },
  {
    path: '/NoticeConfirm',
    name: 'NoticeConfirm',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/noticeConfirm'),
    backPath: ''
  },
  {
    path: '/biddingList',
    name: 'biddingList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/sfd/biddingList.vue')
  },
  {
    path: '/biddingParticulars',
    name: 'biddingParticulars',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/sfd/biddingParticulars.vue')
  },
  {
    path: '/noticeDetailView',
    name: 'noticeDetailView',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/NoticeDetailView.vue')
  },
  {
    path: '/baseNoticeList',
    name: 'baseNoticeList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/NoticeList.vue')
  },
  {
    // 到货验收单列表
    path: '/receiveAcceptList',
    name: 'receiveAcceptList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/receiveAccept/ReceiveAcceptList.vue')
  },
  {
    // 到货验收单详情
    path: '/receiveAcceptDetail',
    name: 'receiveAcceptDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/receiveAccept/ReceiveAcceptDetail.vue')
  },
  {
    // 安装调试收单列表
    path: '/installAcceptList',
    name: 'installAcceptList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/installAccept/InstallAcceptList.vue')
  },
  {
    // 安装调试单详情
    path: '/installAcceptDetail',
    name: 'installAcceptDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/installAccept/InstallAcceptDetail.vue')
  },
  {
    // 资质审查列表
    path: '/qualifyCensorList',
    name: 'qualifyCensorList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/qualifyCensor/QualifyCensorList.vue')
  },
  {
    // 资质审查详情
    path: '/qualifyCensorDetail',
    name: 'qualifyCensorDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/qualifyCensor/QualifyCensorDetail.vue')
  },
  {
    // 供应商冻结/解冻列表
    path: '/dailyManageList',
    name: 'dailyManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/dailyManage/DailyManageList.vue')
  },
  {
    // 供应商冻结/解冻详情
    path: '/dailyManageDetail',
    name: 'dailyManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/dailyManage/DailyManageDetail.vue')
  },
  {
    // 供应商黑名单列表
    path: '/blacklistManageList',
    name: 'blacklistManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/blacklistManage/BlacklistManageList.vue')
  },
  {
    // 供应商黑名单详情
    path: '/blacklistManageDetail',
    name: 'blacklistManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/blacklistManage/BlacklistManageDetail.vue')
  },
  {
    // 供应商注册审批列表
    path: '/supplierRegisterApproveList',
    name: 'supplierRegisterApproveList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierRegister/SupplierRegisterApproveList.vue')
  },
  {
    // 供应商注册领导审批列表
    path: '/supplierRegisterApproveManageList',
    name: 'supplierRegisterApproveManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierRegister/SupplierRegisterApproveManageList.vue')
  },
  {
    // 供应商注册审批详情
    path: '/supplierRegisterApproveDetail',
    name: 'supplierRegisterApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierRegister/SupplierRegisterApproveDetail.vue')
  },
  {
    // 供应商变更审批列表
    path: '/supplierChangeManageList',
    name: 'supplierChangeManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierChange/SupplierChangeManageList.vue')
  },
  {
    // 供应商变更审批详情
    path: '/supplierChangeManageDetail',
    name: 'supplierChangeManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierChange/SupplierChangeManageDetail.vue')
  },
  {
    // 招标发布审批列表
    path: '/biddingPublishList',
    name: 'biddingPublishList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../sfd/biddingPublish/BiddingPublishList.vue')
  },
  {
    // 招标发布审批详情
    path: '/biddingPublishDetail',
    name: 'biddingPublishDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../sfd/biddingPublish/BiddingPublishDetail.vue')
  },
  {
    // 下载附件
    path: '/attachmentDownload',
    name: 'attachmentDownload',
    component: () => import(/* webpackChunkName: 'delivery' */ '../../components/AttachmentDownload.vue')
  },
  {
    // 测试扫一扫功能
    path: '/testScan',
    name: 'testScan',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/TestScan.vue')
  },
  {
    // 内部待办
    path: '/InteriorPendingList',
    name: 'InteriorPendingList',
    component: () => import('@/page/srm/pending/interiorPendingList')
  },
  {
    // 外部待办
    path: '/SupplierPendingList',
    name: 'SupplierPendingList',
    component: () => import('@/page/srm/pending/supplierPendingList')
  },
  {
    path: '/InformList',
    name: 'InformList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/InformList.vue')
  },

]

export default router



// WEBPACK FOOTER //
// ./src/page/srm/config/router.js